;(function () {
  var one

  one = function (dom, event, callback) {
    var handler
    handler = function (e) {
      callback.call(this, e)
      return this.removeEventListener(event, handler)
    }
    return dom.addEventListener(event, handler)
  }

  one(document, "DOMContentLoaded", function (event) {
    var handleEvent, loading, triggered
    loading = false
    triggered = false
    handleEvent = function () {
      var last_item, last_item_offset, more_items_url, window_bottom
      if (!(loading || triggered)) {
        triggered = true
        more_items_url = $(".pagination a[rel=next]").attr("href")
        last_item = $("#infinite-items").children(".item").last()
        if (
          !(last_item != null ? last_item.length : void 0) ||
          !more_items_url
        ) {
          return
        }
        last_item_offset = last_item.offset().top + last_item.outerHeight()
        window_bottom = $(window).scrollTop() + $(window).height()
        if (window_bottom >= last_item_offset) {
          if (more_items_url) {
            loading = true
            $("#loading-indicator").removeClass("hide")
            return $.ajax({
              url: more_items_url,
              success: function (data) {
                var newHTML
                newHTML = $($.parseHTML("<div>" + data + "</div>"))
                $(".pagination").html(newHTML.find(".pagination").html())
                $("#infinite-items").append(newHTML.children())
                $("#infinite-items .pagination").remove()
                $("#infinite-items").trigger("change")
                initPage($("#infinite-items"))
                loading = false
                triggered = false
                return $("#loading-indicator").addClass("hide")
              },
            })
          } else {
            return $("#no-more-elements").removeClass("hide")
          }
        } else {
          return (triggered = false)
        }
      }
    }
    document.addEventListener("scroll", function () {
      return handleEvent()
    })
    return document.addEventListener("wheel", function () {
      return handleEvent()
    })
  })
}).call(this)
